
const Footer = () => (<div />)

export default Footer;
